const PANEL_POSITION_KEY = 'talkr_ai_panel_position';
const PANEL_MIN_VISIBLE_WIDTH = 120;
const PANEL_HEADER_HEIGHT = 56;

export const readStoredPanelPosition = () => {
    try {
        const stored = JSON.parse(window.localStorage.getItem(PANEL_POSITION_KEY));
        if (stored && Number.isFinite(stored.left) && Number.isFinite(stored.top)) return stored;
    } catch (e) { }
    return null;
};

export const storePanelPosition = (position) => {
    try {
        window.localStorage.setItem(PANEL_POSITION_KEY, JSON.stringify(position));
    } catch (e) { }
};

// Keep in sync with AiChatPanel.css (card width and body height)
const PANEL_EXPANDED_WIDTH = 560;
const PANEL_EXPANDED_BODY_HEIGHT = 440;
export const PANEL_EDGE_MARGIN = 8;

export const fitExpandedPanelPosition = (position) => {
    const width = Math.min(PANEL_EXPANDED_WIDTH, window.innerWidth - 32);
    const height = PANEL_HEADER_HEIGHT + Math.min(PANEL_EXPANDED_BODY_HEIGHT, window.innerHeight * 0.62);
    return {
        left: Math.max(PANEL_EDGE_MARGIN, Math.min(position.left, window.innerWidth - width - PANEL_EDGE_MARGIN)),
        top: Math.max(0, Math.min(position.top, window.innerHeight - height - PANEL_EDGE_MARGIN)),
    };
};

export const clampPanelPosition = (position, rect) => ({
    left: Math.min(Math.max(position.left, PANEL_MIN_VISIBLE_WIDTH - rect.width), window.innerWidth - PANEL_MIN_VISIBLE_WIDTH),
    top: Math.min(Math.max(position.top, 0), window.innerHeight - PANEL_HEADER_HEIGHT),
});
